module.exports = __webpack_public_path__ + "static/mathieu_ds-dfbe768a4ccc0995127101b6c5adafd2.jpg";